import { EVENT_DEFAULT_IMAGE } from "modules/event";
import { ComponentProps } from "react";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { useStyles } from "./styles";

export interface IEventCoverArtProps
  extends Omit<ComponentProps<typeof Container>, "children"> {
  src?: string;
}

const EventCoverArt = (props: IEventCoverArtProps) => {
  const { src, style, ...rest } = props;
  const classes = useStyles(props);

  return (
    <Container {...rest} style={style} className={classes.root}>
      <img src={src} className={classes.image} alt="cover" />
    </Container>
  );
};

EventCoverArt.defaultProps = {
  src: EVENT_DEFAULT_IMAGE,
};

export default EventCoverArt;
